<template>
	<div>
		<div class="flex justify-between">
			<div class="mr-6">
				<div v-if="section == 'subsidiary'">
		    		<div>
		    			<label class="text-lg" for="address">What Subsidiary is this Site for?</label>
		    			<div>
				            <table class="mt-4">
				                <thead class="cursor-pointer">
				                    <th class="pl-4">Name</th>
				                    <th class="px-6">Address</th>
				                    <th class="px-6">City</th>
				                    <th class="px-6">State</th>
				                    <th class="px-6">Zip</th>
				                    <th class="px-6"></th>
				                </thead>
				                <tbody>
				                    <tr
				                    	:class="{ 'highlighted': subsidiary.id == row.id }"
				                    	v-for="row in orderBy(subsidiaries, 'name')" :key="row.id">
				                        <td class="pl-4">{{ row.name }}</td>
				                        <td class="px-6">{{ row.address }}</td>
				                        <td class="px-6">{{ row.city }}</td>
				                        <td class="px-6">{{ row.state }}</td>
				                        <td class="px-6">{{ row.postal_code }}</td>
				                        <td class="text-center px-6">
				                            <button v-if="subsidiary.id != row.id" @click="subsidiary = row" class="btn btn-green">Use this Subsidiary</button>
				                        </td>
				                    </tr>
				                </tbody>
				            </table>

				            <div class="flex justify-end mt-4">
								<button @click="showCreateSubsidiary" type="button" class="flex items-center btn btn-blue mr-2">
									<inline-svg name="add-white"></inline-svg>
									<span>Create New Subsidiary</span>
								</button>

					            <button @click="section = 'lease'" v-if="subsidiary.id" type="button" class="flex items-center btn btn-green">
					            	<span>Continue</span>
					            	<inline-svg name="chevron-right"></inline-svg>
					            </button>
							</div>
						</div>
		    		</div>
		    	</div>

				<div v-if="section == 'lease'">
					<label class="text-lg" for="address">Is this Site leased or owned?</label>
					<div class="flex mt-6">
						<div @click="leaseOrOwn = 'Leased'" class="flex flex-col relative mr-10 bg-gray-100 hover:bg-gray-300 border-gray-light shadow-md cursor-pointer">
							<div v-if="leaseOrOwn == 'Leased'" class="absolute top-0 right-0 rounded-full -mt-3 -mr-3">
								<inline-svg name="check-large"></inline-svg>
							</div>
							<div class="p-16">
								<inline-svg name="leased"></inline-svg>
							</div>
							<span class="bg-indigo-600 p-4 text-white text-center uppercase">Leased</span>
						</div>

						<div @click="leaseOrOwn = 'Owned'" class="flex flex-col relative bg-gray-100 hover:bg-gray-300 border-gray-light shadow-md cursor-pointer">
							<div v-if="leaseOrOwn == 'Owned'" class="absolute top-0 right-0 rounded-full -mt-3 -mr-3">
								<inline-svg name="check-large"></inline-svg>
							</div>
							<div class="p-16">
								<inline-svg name="owned"></inline-svg>
							</div>
							<span class="bg-teal-600 p-4 text-white text-center uppercase">Owned</span>
						</div>
					</div>

		            <div class="flex justify-between mt-4">
			            <button @click="section = 'subsidiary'" type="button" class="flex items-center py-2 pr-4 pl-2 btn btn-green">
			            	<svg class="w-6 h-6 fill-current text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M7.05 9.293L6.343 10 12 15.657l1.414-1.414L9.172 10l4.242-4.243L12 4.343z"/></svg>
			            	<span>Back</span>
			            </button>

			            <button @click="section = 'building'" v-if="leaseOrOwn" type="button" class="flex items-center py-2 pr-2 pl-4 btn btn-green">
			            	<span>Continue</span>
			            	<inline-svg name="chevron-right"></inline-svg>
			            </button>
					</div>
				</div>

				<div v-if="section == 'building'">
		    		<div>
		    			<label class="text-lg" for="address">What's the address of your site?</label>
		    			<input @input="debounce" type="text" size="70" ref="search" class="form-input block mt-2 is_search" placeholder="Site Address">
		    		</div>

			        <div v-if="buildings.all.length">
			        	<div class="mt-6">
			        		<span class="text-gray-dark">Select a building below or <button @click="showCreateBuilding" type="button" class="text-indigo-600 hover:text-indigo-500 underline font-medium">create a new one</button> for your site.</span>
			        	</div>
			        	<ul class="flex flex-wrap mt-10 gap-4">
			                <li class="w-64 card relative" v-for="building in buildings.all" :key="building.id">
			                	<a @click="buildingId = building.id">
									<div v-if="buildingId == building.id" class="absolute -top-5 -right-5 rounded-full z-10">
										<inline-svg name="check-large"></inline-svg>
									</div>
			                        <div class="box box-teal">
			                            <div class="flex flex-col">
			                                <div class="relative overflow-hidden">
			                                    <img class="w-full h-48 rounded-t-lg" :src="building.image.view_url">
			                                </div>
			                                <div class="p-4 leading-normal border-b-2 border-gray-300">
			                                    <p class="text-gray-darker font-semibold">{{ building.address_line_1 | truncate(20) }}</p>
			                                    <p class="text-sm">{{ building.city }}, {{ building.state }}  {{ building.postal_code | truncate(5) }}</p>
			                                </div>
			                            </div>
			                        </div>
								</a>
			                </li>
						</ul>
			        </div>

			        <div v-if="noResultsFound" class="w-full my-10 text-center text-xl text-gray-dark">
			        	<span>No buildings found, search again or <button @click="showCreateBuilding" type="button" class="text-indigo-600 hover:text-indigo-500 underline font-medium">create a new building</button> for your site.</span>
			        </div>


			        <inline-svg v-if="loading" name="loading"></inline-svg>

		            <div class="flex justify-between mt-4">
			            <button @click="section = 'lease'" type="button" class="flex items-center py-2 pr-4 pl-2 btn btn-green">
			            	<inline-svg name="chevron-left" classes="w-6 h-6 fill-current text-white"></inline-svg>
			            	<span>Back</span>
			            </button>

			            <button @click="section = 'confirmation'" v-if="buildingId" type="button" class="flex items-center py-2 pr-2 pl-4 btn btn-green">
			            	<span>Continue</span>
			            	<inline-svg name="chevron-right"></inline-svg>
			            </button>
					</div>
			    </div>

			    <div v-if="section == 'confirmation'">
                    <div v-if="readyForCreation">
						<div class="text-lg mb-4">Almost there, confirm the information below then click '<strong>Create Site</strong>'.</div>
	                    <div class="flex flex-col shadow-lg rounded-lg">
	                        <div class="relative overflow-hidden">
	                            <img class="w-full h-64 object-cover rounded-t-lg" :src="building.image.view_url">
	                        </div>
	                        <div class="flex flex-col">
		                        <div class="p-4 leading-normal border-b-2 border-gray-300">
		                            <p class="text-lg font-medium">{{ building.address_line_1 }}</p>
		                            <p class="text-sm">{{ building.city }}, {{ building.state }}  {{ building.postal_code }}</p>
		                        </div>
		                        <div class="flex justify-center flex-grow flex-col p-4">
		                        	<p class="flex items-center">
		                        		<span class="mr-2">
		                        			<inline-svg name="check"></inline-svg>
		                        		</span>
		                        		<span class="text-lg">{{ leaseOrOwn }}</span>
		                        	</p>
		                        	<p class="flex items-center mt-3">
		                        		<span class="mr-2">
		                        			<inline-svg name="check"></inline-svg>
		                        		</span>
		                        		<span class="text-lg">{{ subsidiary.name }}</span>
		                        	</p>
		                        </div>
							</div>
							<button @click="createSite" type="button" class="flex justify-center py-4 btn btn-green rounded-b-lg">Create Site</button>
	                    </div>
					</div>
                    <div v-else>
			        	<div class="mt-6">
			        		<span class="alert red p-6">Site data incomplete, complete the previous steps to create your new site.</span>
			        	</div>
                    </div>
			    </div>
			</div>

			<div class="pl-6 border-l border-dashed border-gray-300" style="min-width: 300px;">
				<div class="bg-brand rounded-t-lg shadow-md">
					<h2 class="font-medium p-4 text-center text-lg text-white">Create New Site</h2>
				</div>
			    <div class="bg-gray-50 rounded-lg px-8 py-6 border">
			    	<ul class="leading-normal">
			    		<li @click="section = 'subsidiary'" class="flex items-center mb-2 cursor-pointer">
			    			<span class="mr-2">
								<inline-svg v-if="subsidiary?.id" name="check"></inline-svg>
								<inline-svg v-else name="x"></inline-svg>
			    			</span>
			    			<span>Subsidiary Information</span>
			    		</li>
			    		<li @click="section = 'lease'" class="flex items-center mb-2 cursor-pointer">
			    			<span class="mr-2">
								<inline-svg v-if="leaseOrOwn" name="check"></inline-svg>
								<inline-svg v-else name="x"></inline-svg>
			    			</span>
			    			<span>Lease Information</span>
			    		</li>
			    		<li @click="section = 'building'" class="flex items-center mb-2 cursor-pointer">
			    			<span class="mr-2">
								<inline-svg v-if="buildingId" name="check"></inline-svg>
								<inline-svg v-else name="x"></inline-svg>
			    			</span>
			    			<span>Building Information</span>
			    		</li>
			    		<li @click="section = 'confirmation'" class="flex items-center mb-2 cursor-pointer">
			    			<span class="mr-2">
								<inline-svg v-if="readyForCreation" name="check"></inline-svg>
								<inline-svg v-else name="x"></inline-svg>
			    			</span>
			    			<span>Create Site</span>
			    		</li>
			    	</ul>
			    </div>
			</div>
		</div>

        <modal name="create-building" width="60%" height="auto" :scrollable="true" draggable=".modal-header">
            <div class="p-8">
                <create-building
                	@buildingCreated="setBuilding($event)"
	                is-modal
	                for-site>
                </create-building>
            </div>
        </modal>

        <modal name="create-subsidiary" width="620" height="auto" :clickToClose="true" :scrollable="true" draggable=".modal-header">
			<create-subsidiary
				:client-id="clientId"
				@subsidiaryCreated="addSubsidiary($event)">
			</create-subsidiary>
		</modal>

		<notifications classes="notification" position="bottom right"></notifications>
	</div>
</template>

<script>
	import { mapState } from 'vuex';

    export default {
    	props: {
    		subsidiaryData: {
    			type: Array,
    			required: true
    		},

    		showSection: {
    			type: String,
    			default: 'subsidiary'
    		},

    		old: {
    			type: [Array, Object],
    			default: () => ({})
    		},

    		clientId: {
    			type: Number,
    			required: false,
    			default: null
    		},

    		wizardMode: {
    			type: Boolean,
    			default: false
    		}
    	},

		data() {
		    return {
		    	section: this.showSection,
		    	subsidiaries: this.subsidiaryData,
		    	criteria: '',
		    	loading: false,
		    	errors: [],

		    	subsidiary: {},
		    	leaseOrOwn: '',
		    	buildingId: ''
		    }
		},

		watch: {
			criteria() {
				this.searchBuildings();
			}
		},

		computed: {
			...mapState(['buildings']),

			noResultsFound() {
				return this.criteria && ! this.loading && ! this.buildings.all.length;
			},

			readyForCreation() {
				return this.subsidiary && this.subsidiary?.id && this.leaseOrOwn && this.buildingId;
			},

			building() {
				return _.find(this.buildings.all, ['id', this.buildingId]);
			}
		},

        methods: {
            debounce: _.debounce(function (criteria) {
        		this.criteria = criteria.target.value;
        	}, 400),

            searchBuildings() {
            	if (! this.criteria) {
            		this.clearBuildings();
            		return;
            	}

            	this.loading = true;

				this.$store.dispatch('loadBuildings', this.criteria)
					.takeAtLeast(300)
					.then((response) => {
						this.loading = false;
					});
			},

			setBuilding(building) {
				this.buildingId = building.id;
				this.buildings.all.push(building);
			},

			clearBuildings() {
				this.buildings.all = '';
				this.buildings.filtered = '';
			},

            showCreateSubsidiary() {
                this.$modal.show('create-subsidiary');
            },

			addSubsidiary(subsidiary) {
				this.subsidiaries.push(subsidiary);
				this.subsidiary = subsidiary;
			},

            showCreateBuilding() {
                this.$modal.show('create-building');
            },

            createSiteConfirmation(buildingId) {
                this.$swal({
                    title: 'Create Site?',
                    text: "Are you sure you want to create a Site?",
                    type: 'question',
                    buttonsStyling: false,
                    confirmButtonText: 'Yes - Create Site',
                    confirmButtonClass: 'btn btn-green',
                    showCancelButton: true,
                    cancelButtonClass: 'btn btn-secondary mr-4',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                    	this.buildingId = buildingId;
                		this.createSite();
                    }
                });
            },

            createSite() {
				axios.post('/sites', {
					'client_id': this.subsidiary.client_id,
					'subsidiary_id': this.subsidiary.id,
					'building_id': this.buildingId,
					'lease_or_own': this.leaseOrOwn
				}).then((response) => {
					if (this.wizardMode) {
						this.$emit('next', response.data.site);
					} else {
						window.location = '/sites/' + response.data.site.id;
					}
				}).catch((error) => {
					console.log(error);
				});
            }
        }
    }
</script>
